<ng-container *transloco="let t">
  @if (isBaseetaSupported) {
    <a
      class="quara-product-widget"
      [ngClass]="source"
      [class.small]="iconSize === 'small'"
      [class.compact]="mode === 'compact'"
      [class.desk]="(lessThan$ | async)?.sm"
      [class.mobile]="(lessThan$ | async)?.mobileL"
      (click)="openAlrajhiOverlay()">
      <div class="flex flex-col flex-wrap align-base">
        <div class="flex flex-wrap">
          @if ((widgetLocale$ | async) === 'en') {
            <span class="small"
              >Split in up to 24 installments with your AlRajhi credit card</span
            >
          } @else {
            <span class="small">قسّط ببطاقة الراجحي الائتمانية على 24 شهرًا</span>
          }
        </div>
      </div>
      <popsy-icon-alrajhi-logo class="icon" [ngClass]="'medium'" aria-hidden="true" />
    </a>
  }
</ng-container>
